import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import Debug from 'debug';
import { Observable } from 'rxjs';
import * as fromActions from '../actions/users.management.actions';
import { IUser } from '../interfaces/user.interface';
import * as fromFeature from '../reducers/users.management.reducer';

const debug = Debug('aumico:aumico-lib-users-fe:UsersManagementProvider');

export interface IUsersManagementProvider {
    dispatchGetUsers: () => void;
    getAllUsers$: () => Observable<IUser[]>;
    getError$: () => Observable<HttpErrorResponse>;
    dispatchUnBlockUser: (userId: string) => void;
    dispatchBlockUser: (userId: string) => void;
    dispatchPromoteToAdmin: (userId: string) => void;
    dispatchDemoteToAdmin: (userId: string) => void;
}

@Injectable({
    providedIn: 'root',
})
export class UsersManagementProvider implements IUsersManagementProvider {
    constructor(private readonly store: Store<fromFeature.AppState>) {
        debug('provider constructed');
    }

    dispatchGetUsers(): void {
        this.store.dispatch(fromActions.userManagement.getUsersForAdmin());
    }
    getAllUsers$(): Observable<IUser[]> {
        return this.store.pipe(select(fromFeature.selectAllUsers));
    }
    dispatchBlockUser(userId: string): void {
        this.store.dispatch(fromActions.userManagement.blockUser({ payload: userId }));
    }
    dispatchUnBlockUser(userId: string): void {
        this.store.dispatch(fromActions.userManagement.unblockUser({ payload: userId }));
    }
    dispatchDeleteUser(userId: string): void {
        this.store.dispatch(fromActions.userManagement.deleteUser({ payload: userId }));
    }

    dispatchPromoteToAdmin(userId: string): void {
        this.store.dispatch(fromActions.userManagement.promoteUserToAdmin({ payload: userId }));
    }
    dispatchDemoteToAdmin(userId: string): void {
        this.store.dispatch(fromActions.userManagement.demoteUserFromAdmin({ payload: userId }));
    }
    dispatchChangeUserRole(userId: string, newRole: string): void {
        this.store.dispatch(fromActions.userManagement.changeUserRole({ userId, newRole }));
    }

    getError$(): Observable<HttpErrorResponse> {
        return this.store.select(fromFeature.selectMngError);
    }
}
